'use client';

import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Container } from '@/components/common/container';

/**
 * Rendered by the RenderErrorBoundary wrapping CompanyDetailPage when the
 * client tree throws. Keeps the header/breadcrumbs/JSON-LD above it intact
 * so the page is still navigable instead of hanging on a frozen subtree.
 */
export function CompanyDetailErrorFallback() {
  const { t } = useTranslation();

  return (
    <Container className="py-10">
      <Card variant="grid">
        <CardContent className="flex flex-col items-center gap-4 py-12 text-center">
          <h2 className="text-lg font-semibold">
            {t(
              'companyDetail.errorFallback.title',
              'Diese Seite ist gerade nicht verfügbar',
            )}
          </h2>
          <p className="max-w-md text-sm text-muted-foreground">
            {t(
              'companyDetail.errorFallback.body',
              'Beim Laden der Unternehmensdetails ist ein Fehler aufgetreten. Bitte versuchen Sie es in einem Moment erneut.',
            )}
          </p>
          <Button onClick={() => window.location.reload()}>
            {t('companyDetail.errorFallback.retry', 'Erneut laden')}
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}
